var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "worklist-page p-10" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("worklist.title")))]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.worklistExecutionType,
            callback: function($$v) {
              _vm.worklistExecutionType = $$v
            },
            expression: "worklistExecutionType"
          }
        },
        [
          _c("el-tab-pane", {
            attrs: { label: _vm.$t("worklist.manual"), name: "MANUAL" }
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: _vm.$t("worklist.automated"), name: "AUTOMATED" }
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: _vm.$t("worklist.all"), name: "ALL" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-card", { staticClass: "worklist-card" }, [_c("ActionTable")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }